import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView')
  },
  {
    path: '/',
    component: () => import('../views/IndexView'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('../views/SensitiveList')
      },
      {
        path: 'ai',
        name: 'AI',
        component: () => import('../views/AiView')
      },
      {
        path: 'detailed-index',
        name: 'DetailedIndex',
        component: () => import('../views/DetailedIndex')
      },
      {
        path: 'export',
        name: 'Export',
        component: () => import('../views/ExportView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('access_token')
  if (!token && to.name !== 'Login') {
    next({ name: 'Login' })
  } else if (token && to.name === 'Login') {
    next({ name: 'Home' })
  } else {
    next()
  }
})

export default router
